import {DependencyList, useContext, useEffect} from 'react';
import {CarecoApiContext} from '@/app-context/careco-api-context';

export function useWebSocketError(
  onError: (message: string) => void,
  deps: DependencyList = [],
) {
  const { webSocketApi } = useContext(CarecoApiContext);

  useEffect(() => {
    webSocketApi?.onError(onError);

    return () => {
      webSocketApi?.onError(() => {});
    };
  }, deps);
}
